import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BpService } from '../../../../core/services/bp.service';
import { RetailPlaceConnectVpnFields } from '../vpn.model';
import { REGEXP_EXCLUDE_DIGITS, REGEXP_ONLY_DIGITS } from '../../../../core/services/regexp';

@Component({
  selector: 'tax-vpn-form',
  templateUrl: './vpn-form.component.html',
  styleUrls: ['./vpn-form.component.sass'],
})
export class VpnFormComponent implements OnInit, OnDestroy {
  // @ts-ignore
  @Input() retailPlaceData: RetailPlaceConnectVpnFields;

  @Output() continueProcess: EventEmitter<RetailPlaceConnectVpnFields> = new EventEmitter<RetailPlaceConnectVpnFields>();
  @Output() errorMsg: EventEmitter<string> = new EventEmitter<string>();

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private bpService: BpService,
    private location: Location,
  ) { }

  ngOnInit(): void {
    this.retailPlaceData.phone = '';
  }

  back(): void {
    this.location.back();
  }

  continue(): void {
    // @ts-ignore
    this.retailPlaceData.phone = this.retailPlaceData.phone.match(REGEXP_ONLY_DIGITS).join('');
    this.continueProcess.emit(this.retailPlaceData);
  }

  isFormValid(): boolean {
    return this.retailPlaceData.responsiblePerson
      && this.retailPlaceData.phone
      && this.retailPlaceData.kkmAmount
      && this.retailPlaceData.phone.replace(REGEXP_EXCLUDE_DIGITS, '').length === 11;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
